const updatePlayerDuel = (state = {}, action) => {
    const { type = null, datasource, data = {} } = action;
    if (type === 'dataEngine_update_response') {
        if (datasource === 'playerDuel') {
            const {
                playerId,
                playerStats: {
                    pitcher: {
                        id: opponentId
                    } = {},
                    stat
                } = {}
            } = data;
            const updatedPlayer = opponentId && {
                [playerId]: {
                    opponents: {
                        ...state?.playerId?.opponents,
                        [opponentId]: {
                            ...stat
                        }
                    }
                }
            };
            return { ...state, ...updatedPlayer, isLoadingMatchupStats: false };
        }
    }
    if (type === 'matchup_stats_loading') {
        const { isLoadingMatchupStats } = data;
        return { ...state, isLoadingMatchupStats };
    }
    return state;
};

export default updatePlayerDuel;
